import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型
import { TopUpOrder } from '../../service/class/TopUpOrder';

// 借助 createSlice 创建 reducer、action
const TopUpOrderDetailSlice = createSlice({
    name: 'topUpOrderDetail',
    initialState: {
        value: new TopUpOrder(),
    },
    reducers: {
        setTopUpOrderDetail: (state, action: PayloadAction<TopUpOrder>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setTopUpOrderDetail } = TopUpOrderDetailSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const topUpOrderDetailSelector = (state: RootState) => state.topUpOrderDetail.value;

// Reducer，真正执行修改 state 的纯函数
export default TopUpOrderDetailSlice.reducer;
